import React, { useCallback } from 'react';
import { Button } from '@framework-controls/core';
import css from './CalendarSelectAppt.module.scss';
import classNames from 'classnames';
import { Transportation } from 'src/models';
import { strings } from 'src/localization';

interface IProps {
    id: string;
    time: string;
    transportation: Transportation;
    // type: string;
    label: string;
    timeHandler: (event: React.MouseEvent<HTMLElement, MouseEvent>, time: string, transportation: Transportation) => void;
    selected: boolean;
    theme: string;
}

const CalendarSelectApptTimeBtn = (props: IProps) => {
    let btnClassName = classNames(
        css.timeBtn,
        {
            [css.timeBtnChecked]: props.selected,
        },
    );
    if (props.theme === 'colorSensitive') {
        btnClassName = classNames(
            css.timeBtnCS,
            {
                [css.timeBtnCheckedCS]: props.selected,
            },
        );
    }

    let contentsClassName = classNames(
        css.timeBtnContents,
        {
            [css.timeBtnContentsChecked]: props.selected,
            [css.timeBtnContentsCheckedCA]: props.theme === 'cadillac' && props.selected,
        },
    );

    if (props.theme === 'colorSensitive') {
        contentsClassName = classNames(
            css.timeBtnContentsCS,
            {
                [css.timeBtnContentsCheckedCS]: props.selected,
            },
        );
    }

    const subBtnClassName = classNames(
        css.timeSubBtn,
        {
            [css.timeSubBtnChecked]: props.selected,
        },
    );

    const timeHandler = useCallback((event: any) => {
        props.timeHandler(event, props.time, props.transportation);
    }, [props.time, props.transportation, props.timeHandler]);

    let timeLit = props.label;
    if (props.transportation.type === 'N') {
        timeLit = strings.BeforeLit + props.label;
    }

    return (
        <div className={btnClassName}>
            <div className={subBtnClassName}>
                <Button
                    id={props.id + 'btn'}
                    onClick={(event) => timeHandler(event)}
                    type='text'
                >
                    <span className={contentsClassName}>{timeLit}</span>
                </Button>
            </div>
        </div>
    );
};
export default CalendarSelectApptTimeBtn;